import { useContext } from 'react';
import { HomeContext } from './homeContext';

const useHome = () => {
    const context = useContext(HomeContext);

    if (!context) throw new Error('dropdown context must be use inside DropdownDataProvider');

    return context;
};

export default useHome;